{
 "name": "0_plant_flower_3",
 "bin": "0_plant_flower_3.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_flower_3", "parent": 1, "t": [-0.7091904,-2.84309,0], "q": [-0.03588668,-0.806555,0.02816552,0.5893962], "s": [1,1,1]},
  {"name": "", "parent": 10, "t": [0.4029665,6.769385,-0.6969318], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Capsule02", "parent": 10, "t": [0.4029636,-0.7425699,-0.6969318], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]},
  {"name": "Capsule01", "parent": 10, "t": [0.4029636,-0.7425699,-0.6969318], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 120, "posOffset": 0, "nrmOffset": 1440, "uvOffset": 2880, "material": "0_plant_flower3", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_3.png"},
  {"node": 13, "vertexCount": 120, "posOffset": 3840, "nrmOffset": 5280, "uvOffset": 6720, "material": "0_plant_flower3", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_3.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 7680},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 21680},
  {"name": "idle", "duration": 0.8, "fps": 30, "frames": 25, "offset": 77680},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 91680}
 ]
}
